import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import useFeatureEnabled from '@src/hooks/useFeatureEnabled';
import HoldingJobs from './HoldingJobsModal';
import { useSidebarStore } from './useSideBarStore';
import React, { useEffect } from 'react';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

const SideDrawer: React.FC = () => {
    const {
        showSideBar,
        sideBarMenus,
        setShowSideBar,
        setSideBarMenus,
        handleMenuClick,
    } = useSidebarStore();

    const globalSearchEnabled = useFeatureEnabled("SideDrawer", "GlobalJobSearch");
    const holdingJobsEnabled = useFeatureEnabled("SideDrawer", "HoldingJobs");
    const useSideBar = useFeatureEnabled("Layout", "SideBar");

    // Update sidebar menus based on feature flags
    useEffect(() => {
        const menus: string[] = [];
        if (globalSearchEnabled) menus.push("Booking Search");
        if (holdingJobsEnabled) menus.push("Holding Jobs");
        setSideBarMenus(menus);
    }, [globalSearchEnabled, holdingJobsEnabled, setSideBarMenus]);

    // Sidebar content
    const list = (anchor: Anchor) => (
        <Box sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }} role="presentation">
            <List>
                {sideBarMenus.map((text, index) => (
                    <ListItem key={text} disablePadding>
                        <ListItemButton onClick={() => handleMenuClick(text)}>
                            <ListItemIcon>
                                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                            </ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
        </Box>
    );

    // Conditionally render the sidebar and the HoldingJobs modal
    if (!useSideBar) return null;

    return (
        <>
            {/* Drawer component */}
            <Drawer anchor="left" open={showSideBar} onClose={() => setShowSideBar(false)}>
                {list("left")}
            </Drawer>

            {/* Holding Jobs Modal */}
            {holdingJobsEnabled && <HoldingJobs />}
        </>
    );
}

SideDrawer.displayName = "SideDrawer";

export default React.memo(SideDrawer);
